import {
  signIn as _signIn,
  signUp as _signUp,
  signOut,
  confirmSignUp,
  confirmSignIn,
  resendSignUpCode,
  autoSignIn,
  updateUserAttributes,
  getCurrentUser as _getCurrentUser,
  fetchAuthSession as _fetchAuthSession,
  fetchUserAttributes as _fetchUserAttributes,
} from 'aws-amplify/auth';
import { tierFromGroups } from './featureConfig';

export {
  signOut,
  confirmSignUp,
  confirmSignIn,
  resendSignUpCode,
  autoSignIn,
  updateUserAttributes,
};

export async function signIn(params) {
  const mock = window.__MOCK_AMPLIFY_SIGN_IN__;
  if (mock) {
    if (mock.__error) throw new Error(mock.__error);
    return mock;
  }
  return _signIn(params);
}

export async function signUp(params) {
  const mock = window.__MOCK_AMPLIFY_SIGN_UP__;
  if (mock) {
    if (mock.__error) throw new Error(mock.__error);
    return mock;
  }
  return _signUp(params);
}

export async function getCurrentUser() {
  if (window.__MOCK_AMPLIFY_USER__) return window.__MOCK_AMPLIFY_USER__;
  return _getCurrentUser();
}

export async function fetchAuthSession(opts) {
  if (window.__MOCK_AMPLIFY_SESSION__) return window.__MOCK_AMPLIFY_SESSION__;
  return _fetchAuthSession(opts);
}

export async function fetchUserAttributes() {
  if (window.__MOCK_AMPLIFY_ATTRIBUTES__) return window.__MOCK_AMPLIFY_ATTRIBUTES__;
  return _fetchUserAttributes();
}

/**
 * Force a token refresh and return the freshly-derived tier. Cognito group changes
 * (e.g. Premium added on purchase) only reach the client when a new token is issued;
 * forceRefresh re-mints the ID/access tokens via the refresh-token flow so the new
 * `cognito:groups` claim is reflected without a sign-out. See xdesign_docs/billing.md §3.
 */
export async function refreshEntitlement() {
  const session = await fetchAuthSession({ forceRefresh: true });
  const groups = session?.tokens?.idToken?.payload?.['cognito:groups'] || [];
  return tierFromGroups(groups);
}

/**
 * Poll a forced token refresh until tier >= minTier or attempts run out. The Cognito
 * group is added asynchronously by the Stripe webhook, so the first refresh after a
 * purchase may still be stale. Returns the final tier (caller decides on timeout).
 */
export async function waitForTier(minTier, { attempts = 5, intervalMs = 2500 } = {}) {
  let tier = 0;
  for (let i = 0; i < attempts; i++) {
    tier = await refreshEntitlement();
    if (tier >= minTier) return tier;
    if (i < attempts - 1) await new Promise(r => setTimeout(r, intervalMs));
  }
  return tier;
}
